import { useState, useEffect, useCallback } from 'react';

const useReCaptchaV3 = (siteKey: any) => {
	const [isReCaptchaReady, setIsReCaptchaReady] = useState(false);

	useEffect(() => {
		if (window.grecaptcha) {
			setIsReCaptchaReady(true);
		} else {
			const script = document.createElement('script');
			script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
			script.async = true;
			document.head.appendChild(script);
			script.onload = () => setIsReCaptchaReady(true);
		}

		return () => {
			window.onRecaptchaLoad = null;
		};
	}, [siteKey]);

	const executeReCaptcha = useCallback(
		async (action: any) => {
			if (isReCaptchaReady && window.grecaptcha) {
				return await window.grecaptcha.execute(siteKey, { action });
			}
			return null;
		},
		[isReCaptchaReady, siteKey],
	);

	return executeReCaptcha;
};

export default useReCaptchaV3;
